const latePayment = Object.freeze({
  CURRENT: 'Current',
  DAYS_30: '30 Days',
  DAYS_60: '60 Days',
  DAYS_90_PLUS: '90+ Days',
  UNKNOWN: 'Unknown'
})

export { latePayment }
